import { render } from "./SelectionBlock.vue?vue&type=template&id=d6644fd2"
import script from "./SelectionBlock.vue?vue&type=script&lang=js"
export * from "./SelectionBlock.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__